// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"Options_text-gradient__1haoN","options":"Options_options__mmhD7","favorite":"Options_favorite__Fmd_z","button":"Options_button__eQcJB"};